/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export const SET_LOCATION_URL = 'SET_LOCATION_URL';
